import { api } from './client'

export type AwsAccessRegionStatus =
  | 'healthy'
  | 'assume_role_failed'
  | 'rds_access_failed'
  | 'unknown_error'

export type AwsAccessOverallStatus =
  | 'healthy'
  | 'partial'
  | 'access_denied'
  | 'role_not_found'
  | 'no_account_id'
  | 'unknown_error'
  | 'unknown'

export interface AwsAccessRegion {
  region: string
  status: AwsAccessRegionStatus
  instances_count: number
  error_code: string | null
  error_message: string | null
}

export interface AwsAccessStatus {
  tenant_id: number
  account_id: string | null
  overall_status: AwsAccessOverallStatus
  regions: AwsAccessRegion[]
  diagnosed_at_epoch: number
}

export const awsAccessApi = {
  getStatus: (tenantId: number) =>
    api
      .get<AwsAccessStatus>(`/v1/admin/tenants/${tenantId}/aws-access/status`)
      .then((r) => r.data),

  diagnose: (tenantId: number) =>
    api
      .post<AwsAccessStatus>(`/v1/admin/tenants/${tenantId}/aws-access/diagnose`)
      .then((r) => r.data),
}

const HUMAN_OVERALL: Record<AwsAccessOverallStatus, string> = {
  healthy: 'Acesso AWS funcionando',
  partial: 'Acesso parcial — algumas regiões falharam',
  access_denied: 'Acesso negado — role IAM não confia na conta ConsoleAI',
  role_not_found: 'Role ConsoleAIReadRole não existe na conta tenant',
  no_account_id: 'Tenant sem account_id configurado — provisionamento pendente',
  unknown_error: 'Erro inesperado ao acessar AWS',
  unknown: 'Acesso AWS ainda não diagnosticado',
}

export function humanizeOverallStatus(s: AwsAccessOverallStatus): string {
  return HUMAN_OVERALL[s] ?? s
}
